import { Outlet } from "react-router-dom";

export default function ECP() {
  return <Outlet />;
}
